import { render, staticRenderFns } from "./CampoPesquisaModelo.vue?vue&type=template&id=82b53f72"
import script from "./CampoPesquisaModelo.vue?vue&type=script&lang=js"
export * from "./CampoPesquisaModelo.vue?vue&type=script&lang=js"
import style0 from "./CampoPesquisaModelo.vue?vue&type=style&index=0&id=82b53f72&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports